import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import ClientForm from "../components/ClientForm";
import Preloader from "../components/Preloader";
import {
    loadClient,
    removeClient,
    cardCancelInWork,
    cardInWork,
    editCardRequest,
    editCardError,
    loadClientAction,
    loadSalesOrdersOfSupplierRequest,
    loadSalesOrdersOfSupplierSuccessfully,
    loadSalesOrdersOfSupplierFailed,
    createSalesOrderRequest,
    createSalesOrderSuccessfully,
    createSalesOrderFailed,
    cancelSalesOrderSuccessfully,
    cancelSalesOrderFailed,
    cancelSalesOrderRequest,
} from "../actions/clientsActions";
import { loadUsers } from "../actions/userActions";
import { SUPPLIER } from "../constants/routes";
import {
  parseUrl,
  translateServerError,
  prepareUsersForSelect, createRedirectUrlFromType
} from "../helpers/core";

import { updateTableOfChanging } from "../actions/updateTableOfChanging";
import editCardHttpHandler, {
  Contact,
  EditCardRequest,
  GrainVolume
} from "../apiClient/Card/Edit";
import getSalesOrders from "../apiClient/SalesOrder/GetListBySupplier";
import createSalesOrderHandler, {
  CreateSalesOrderRequest,
} from "../apiClient/SalesOrder/Create";
import cancelSalesOrderHandler from "../apiClient/SalesOrder/Cancel";

class SupplierDetailPage extends Component {
  id = this.props.location.search && parseUrl(this.props.location.search).id;

  componentWillMount() {
    this.loadSupplier();
    this.props.loadUsers();
  }

  loadSupplier()
  {
      if (this.id) {
		  this.props.loadClient(this.id);
		  this.props.getSalesOrdersBySupplier(this.id);
	  }
  }

  onClientChange = data => {
    this.props.changeClient(data);
  };

  onClientRemove = () => {
    if (
      !window.confirm(
        "Вы уверены, что хотите удалить Поставщика? Действие необратимо"
      )
    )
      return;
    this.props.removeClient(this.id);
  };

  onInWork = id => {
      this.props.cardInWork(id, () => this.loadSupplier());
  };

  onCancelInWork = id => {
      this.props.cardCancelInWork(id, () => this.loadSupplier());
  };

  getSalesOrdersByCulture = cultureId => {
    return this.props.salesOrders.filter(
        salesOrder => salesOrder.cultureId === cultureId
    )
  }

  render() {
    if (!this.id) {
      return (
        <div className="container">
          <h4>Некорректный адрес.</h4>
          <p>
            Рекомендуем перейти к <Link to={SUPPLIER}>списку поставщиков</Link>.
          </p>
        </div>
      );
    }

    const {
      loading,
      supplier,
      initData,
      error,
      priceUpdating,
      modules,
      users,
      updateTableOfChanging,
      changes
    } = this.props;
    const userForSelect = users.length ? prepareUsersForSelect(users) : [];

    if (loading) {
      return <Preloader />;
    }

    if (!loading && !supplier) {
      return (
        <div className="container">
          <h4>Поставщик успешно удален.</h4>
          <p>
            Перейти к <Link to={SUPPLIER}>списку поставщиков</Link>.
          </p>
        </div>
      );
    }

      if (supplier.type !== 1) {
        window.location.href = createRedirectUrlFromType(
            supplier.id,
            parseInt(supplier.type)
        )
      }

      const type = initData.client_type.find(el => el.label === "Поставщик");

    return (
      <ClientForm
        isEditMode
        client={supplier}
        initData={initData}
        moveCultureToHistory={() => {}}
        type={type ? type.value : ""}
        onSubmit={this.onClientChange}
        onRemove={this.onClientRemove}
        serverError={error}
        priceUpdating={priceUpdating}
        showCalleeAsign={modules.assign_call}
        showDeleteAction={modules.can_delete}
		showInWorkButton={true}
		showCancelInWorkButton={true}
        users={userForSelect}
        updateTableOfChanging={updateTableOfChanging}
        changes={changes}
		onInWork={this.onInWork}
		onCancelInWork={this.onCancelInWork}
        salesOrders={this.props.salesOrders}
        getSalesOrdersByCulture={this.getSalesOrdersByCulture}
        createSalesOrder={this.props.createSalesOrder}
        cancelSalesOrder={this.props.cancelSalesOrder}
      />
    );
  }
}

const getSalesOrdersBySupplier = (dispatch, supplierId) => {

  dispatch(loadSalesOrdersOfSupplierRequest);

  getSalesOrders
      .getBySupplier(supplierId)
      .subscribe(
          (salesOrders) => {
            dispatch(loadSalesOrdersOfSupplierSuccessfully(salesOrders));
          },
          (error) => {
            dispatch(loadSalesOrdersOfSupplierFailed(error.error.join("\n")));
          }
      );
}

const createSalesOrder = (dispatch,
                          supplierId,
                          price,
                          volumeId,
                          cultureId,
                          locationId,
                          volume,
                          quality) => {

  dispatch(createSalesOrderRequest);

  createSalesOrderHandler.create(new CreateSalesOrderRequest(
      price,
      volumeId,
      cultureId,
      locationId,
      volume,
      quality,
      )
  ).subscribe(
      (response) => {
          dispatch(createSalesOrderSuccessfully());
          document.location.reload();
      },
      (error) => {
          dispatch(createSalesOrderFailed(error.error.join("\n")));
      })
}

const cancelSalesOrder = (dispatch, salesOrderId) => {

  dispatch(cancelSalesOrderRequest());

    cancelSalesOrderHandler.cancel(salesOrderId)
        .subscribe(
            (response) => {

                dispatch(cancelSalesOrderSuccessfully());
                document.location.reload();
            },
            (error) => {
                dispatch(cancelSalesOrderFailed(error.error.join("\n")));
            })
}

const editCard = (dispatch, data) => {

  dispatch(editCardRequest);

  editCardHttpHandler.edit(data.client.id, new EditCardRequest(
      data.client.type || null,
      data.client.name || null,
      data.client.email || null,
      data.client.address || null,
      data.client.lat || null,
      data.client.lon || null,
      data.client.geo_id || null,
      data.client.area_full || null,
      data.client.will_callee_id || null,
      data.client.date_will_call || null,
      data.client.call_aim || null,
      data.client.additional_info || null,
      data.client.contract || false,
      data.client.vat || 1,
      data.client.websites,
      data.client.filials.map((filialData) => filialData.id),
      data.client.categories,
      data.client.contacts.map((contactData) => new Contact(
        contactData.name,
        contactData.phone,
        contactData.email,
        contactData.isVisible,
      )),
      data.client.cultures.map((grainData) => new GrainVolume(
          grainData.culture_id,
          grainData.price,
          grainData.volume,
          grainData.quality_comment,
          grainData.link_id ? grainData.link_id : null
      )),
      data.client.date_called || null
      )
  ).subscribe(
      (response) => {
        loadClientAction(data.client.id, dispatch);
      },
      (error) => {
        dispatch(editCardError(error.error.join("\n")));
      })
}

SupplierDetailPage.propTypes = {
  supplier: PropTypes.object,
  location: PropTypes.object,
  initData: PropTypes.object,
  loading: PropTypes.bool,
  priceUpdating: PropTypes.bool,
  loadClient: PropTypes.func.isRequired,
  changeClient: PropTypes.func.isRequired,
  removeClient: PropTypes.func.isRequired,
  loadUsers: PropTypes.func.isRequired,
  error: PropTypes.string,
  modules: PropTypes.object,
  users: PropTypes.array
};

const mapStateToProps = state => ({
  changes: state.changing.dataOfChanging,
  supplier: state.clients.list[0],
  loading: state.clients.loading,
  priceUpdating: state.clients.priceUpdating,
  initData: state.webInterface.initData,
  error: translateServerError(state.clients.error),
  modules: state.webInterface.initData
    ? state.webInterface.initData.available_modules
    : {},
  users: state.users.list,
  salesOrders: state.clients.salesOrders
});

const mapDispatchToProps = dispatch => ({
  loadClient: id => dispatch(loadClient(id)),
  changeClient: data => editCard(dispatch, data),
  getSalesOrdersBySupplier: supplierId => getSalesOrdersBySupplier(dispatch, supplierId),
  createSalesOrder: (supplierId, price, volumeId, cultureId, locationId, volume, quality) =>
      createSalesOrder(dispatch, supplierId, price, volumeId, cultureId, locationId, volume, quality),
  cancelSalesOrder: salesOrderId => cancelSalesOrder(dispatch, salesOrderId),
  removeClient: id => dispatch(removeClient(id)),
  loadUsers: () => dispatch(loadUsers()),
  updateTableOfChanging: id => dispatch(updateTableOfChanging(id)),
  cardInWork: (id, callback) => dispatch(cardInWork(id, callback)),
  cardCancelInWork: (id, callback) => dispatch(cardCancelInWork(id, callback))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierDetailPage);



// WEBPACK FOOTER //
// ./containers/SupplierDetailPage.js